// extracted by mini-css-extract-plugin
module.exports = {"visitedColor":"#75e1ff","shortestColor":"#cf2541","fixedColor":"#000","clickedColor":"#fcba03","initialColor":"#a1a6a3","boardRow":"16","boardCol":"30"};